// @flow
import type { DictionaryType } from "../types/GeneralTypes";

export const iconStyles = (theme: DictionaryType): DictionaryType => ({
  lightIcon: {
    color: theme.palette.primary.contrastText,
    "&:hover": {
      color: theme.palette.primary.contrastText
    }
  },
  shineIcon: {
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.third
    }
  },
  greenIcon: {
    color: theme.palette.primary.main
  },
  inheritIcon: {
    fill: "currentColor",
    color: "currentColor"
  },
  mediumIcon: {
    width: "30px",
    height: "30px"
  },
  largeIcon: {
    width: "100px",
    height: "100px"
  }
});

export type IconStylesClassesType = {
  lightIcon: DictionaryType,
  shineIcon: DictionaryType,
  greenIcon: DictionaryType,
  inheritIcon: DictionaryType,
  mediumIcon: DictionaryType,
  largeIcon: DictionaryType
};
